export default {
  Model: {},
  Actions: {
    GET_EMPLOYEES_EMAIL_SUCCESS: 'PiEmployeeItems/GET_EMPLOYEES_EMAIL_SUCCESS',
  },
  State: {
    EMPLOYEES_EMAIL: 'EMPLOYEES_EMAIL',
  },
};
